import { jsPDF } from 'jspdf';
import { CostBreakdown } from '../types/renovation';
import { Language } from '../types/language';

interface GeneratePDFParams {
  breakdown: CostBreakdown[];
  totalCost: number;
  language: Language;
  userData: {
    email: string;
  };
}

export function generatePDF(params: GeneratePDFParams): void {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  
  // Company header
  doc.setFontSize(24);
  doc.setFont('helvetica', 'bold');
  doc.text('AMG Bâtiment', pageWidth / 2, 20, { align: 'center' });
  
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text('+33 6 81 41 81 07', pageWidth / 2, 30, { align: 'center' });
  doc.text('projects@abatiment.com', pageWidth / 2, 35, { align: 'center' });

  // Title
  doc.setFontSize(20);
  doc.setFont('helvetica', 'bold');
  doc.text(params.language === 'fr' ? 'Devis de Rénovation' : 'Renovation Quote', pageWidth / 2, 50, { align: 'center' });

  // Customer details
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('Client Details:', 15, 65);
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text(`Email: ${params.userData.email}`, 15, 75);

  // Services breakdown
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text(params.language === 'fr' ? 'Détail des Services' : 'Services Breakdown', 15, 90);
  
  let yPosition = 100;
  
  // Table headers
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text(params.language === 'fr' ? 'Service' : 'Service', 15, yPosition);
  doc.text('m²', 120, yPosition);
  doc.text('€/m²', 140, yPosition);
  doc.text('€', 170, yPosition);
  
  yPosition += 5;
  doc.line(15, yPosition, 195, yPosition);
  yPosition += 10;

  // Table content
  doc.setFont('helvetica', 'normal');
  params.breakdown.forEach((item) => {
    const serviceName = params.language === 'fr' ? item.categoryFr : item.category;
    doc.text(serviceName, 15, yPosition);
    doc.text(item.details.area.toFixed(2), 120, yPosition);
    doc.text(item.details.ratePerSqm.toString(), 140, yPosition);
    doc.text(item.cost.toFixed(2), 170, yPosition);
    yPosition += 7;
  });

  // Total
  yPosition += 5;
  doc.line(15, yPosition, 195, yPosition);
  yPosition += 10;
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text(params.language === 'fr' ? 'Total (Hors TVA)' : 'Total (Excl. VAT)', 15, yPosition);
  doc.text(`${params.totalCost.toFixed(2)} €`, 170, yPosition);

  // Footer
  const footerText = params.language === 'fr' 
    ? 'Ce devis est une estimation. Les prix peuvent varier selon les spécificités du projet.'
    : 'This quote is an estimate. Prices may vary based on project specifics.';
  
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.text(footerText, pageWidth / 2, 270, { align: 'center' });
  doc.text('AMG Bâtiment - +33 6 81 41 81 07 - projects@abatiment.com', pageWidth / 2, 275, { align: 'center' });

  // Save the PDF
  doc.save('renovation-quote.pdf');
}